import React from "react";

const SITE = "https://narwhalhub.com";

// React 19 hoists <title>/<meta>/<link> rendered anywhere into <head>.
export const Seo = ({ title, description, keywords, image, type = "website" }) => {
  const pathname = typeof window !== "undefined" ? window.location.pathname : "/";
  const url = pathname === "/" ? `${SITE}/` : `${SITE}${pathname}`;
  const abs = (img) => (img ? (img.startsWith("http") ? img : `${SITE}${img}`) : `${SITE}/narwhal-logo.png`);
  const ogImage = abs(image);
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <link rel="canonical" href={url} />
      <meta property="og:site_name" content="Narwhal" />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </>
  );
};

export default Seo;
